import { render, staticRenderFns } from "./GroupListDevShow.vue?vue&type=template&id=d6011b00&scoped=true"
import script from "./GroupListDevShow.vue?vue&type=script&lang=js"
export * from "./GroupListDevShow.vue?vue&type=script&lang=js"
import style0 from "./GroupListDevShow.vue?vue&type=style&index=0&id=d6011b00&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6011b00",
  null
  
)

export default component.exports